import axios from 'axios';
import { APP_CONFIG } from './constants';
import { authManager } from './services/authManager';

const api = axios.create({
  baseURL: APP_CONFIG.BASE_URL,
});

// Request interceptor to add the token
api.interceptors.request.use(
  config => {
    const newConfig = { ...config };
    if (authManager.token) {
      newConfig.headers = config.headers || {};
      newConfig.headers.Authorization = `Bearer ${authManager.token}`;
    }
    return newConfig;
  },
  error => Promise.reject(error)
);

// Response interceptor to handle token expiration/auth errors
api.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    const status = error.response?.status;

    // If it's a 401/403 and we haven't retried yet, try to refresh/re-login
    if ((status === 401 || status === 403) && !originalRequest.retryAttempt) {
      const retryRequest = { ...originalRequest, retryAttempt: true };
      try {
        const token = await (async () => {
          if (authManager.onRefresh) {
            // Try to trigger refresh in host app
            const newToken = await authManager.onRefresh();
            // Some implementations might return the token, others update the store via sync
            return (newToken as string | undefined) || authManager.token;
          }
          // Fallback to internal login for POC
          return authManager.login();
        })();

        if (token) {
          retryRequest.headers = retryRequest.headers || {};
          retryRequest.headers.Authorization = `Bearer ${token}`;
          return await api(retryRequest);
        }
      } catch (err) {
        console.error('[SOAR API] Refresh/Login failed:', err);
        // If refresh/login fails, redirect or reject
        return Promise.reject(err);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
